/**
 * Elevation tokens.
 *
 * Two shadow families appear on the landing frame:
 *   - `card`   — soft downward drop for floating cards (search filter,
 *                madlib pill chips, mint-section cards).
 *   - `subtle` — barely-there separator shadow used under the top nav on
 *                scroll.
 *
 * TODO(figma): confirm the effect stack from Figma's inspect panel for
 * the search card (59:24344) and the mint cards (59:24267).
 */
export const elevations = {
  none: 'none',
  subtle: '0 1px 2px rgba(11, 27, 61, 0.06)',
  // Soft drop under the sticky top nav, matching the Figma banner shadow.
  nav: '0 4px 16px rgba(11, 27, 61, 0.08)',
  card: '0 12px 32px rgba(11, 27, 61, 0.08)',
  cardHover: '0 18px 40px rgba(11, 27, 61, 0.12)',
} as const;

declare module '@mui/material/styles' {
  interface Theme {
    elevations: typeof elevations;
  }
  interface ThemeOptions {
    elevations?: typeof elevations;
  }
}
